import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Styles from "../../styles/vendorDashboard.module.css";

import { RightArrowLink, Search } from "../../shared/assets/icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const columns = [
  { field: "campaign", headerName: "CAMPAIGN ", width: 130 },
  { field: "owner", headerName: "CAMPAIGN OWNER", width: 130 },
  { field: "Timeline", headerName: "TIMELINE ", width: 130 },
  { field: "Kam", headerName: "KAM", width: 130 },
  { field: "Team", headerName: "TEAM", width: 130 },
  { field: "RfpFile", headerName: "RFP FILE", width: 120 },
  { field: "Status", headerName: "STATUS", width: 180 },
  { field: "Action", headerName: "ACTION", width: 90 },
];

const Campaigns = () => {
  const navigate = useNavigate();
  const clientId = localStorage.getItem("clientId");

  const [organizationListLoading, setOrganizationListLoading] = useState(false);

  const [page, setPage] = React.useState(1);
  const [selected, setSelected] = React.useState([]); // State for selected rows
  const [isOrganizationId, setOrganizationId] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [kamdata, setKamdata] = useState([]);

  const [pageSize, setPageSize] = useState(20);
  const pageSizeOptions = [1, 5, 10, 20, 50, 100];
  const [RFPCount, totalRFPCount] = useState(null); // State to store the updated data

  const [allRfp, setAllRfp] = useState([]);

  const [searchInputs, setSearchInputs] = useState({
    campaign: "",
  });
  const serverURL = process.env.REACT_APP_URL;

  // Fetch RFP data
  const fetchAllRFP = async (
    page,
    limit,
    organizationId = null,
    filters = {}
  ) => {
    setOrganizationListLoading(true);

    try {
      const params = {
        page,
        limit,
        ...filters,
      };

      if (organizationId) {
        params.organizationId = organizationId;
      }

      const response = await axios.get(
        `${serverURL}/requestForProposal/viewAllRfp`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params,
        }
      );

      if (response.data.success) {
        setAllRfp(response?.data?.data);
        totalRFPCount(response?.data?.totalRfp);
        setKamdata(response?.data?.adminsData);
        setTotalPages(response?.data?.totalPages);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setOrganizationListLoading(false);
    }
  };

  let organizationId;
  const clientDetails = async (clientId) => {
    setOrganizationListLoading(true);

    try {
      const userDetails = await axios.get(
        `${serverURL}/client/dashboard/${clientId}`
      );
      if (userDetails.data.success) {
        organizationId = userDetails.data.data.organizationId;
        let page = 1;
        let limit = 20;
        setOrganizationId(organizationId);

        fetchAllRFP(page, limit, organizationId);
      }
    } catch (error) {
      console.error("error in getting user details", error);
    }
  };

  useEffect(() => {
    clientDetails(clientId);
  }, []);
  const handlePageChange = async (e, value) => {
    setPage(value);

    const filters = {};
    Object.entries(searchInputs).forEach(([key, val]) => {
      if (val.trim() !== "") {
        filters[key] = val;
      }
    });

    await fetchAllRFP(value, pageSize, isOrganizationId, filters);
  };

  const handlePageSizeChange = async (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    const filters = {};

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    const page = 1;
    const limit = newSize;

    queryParams.set("page", page);
    queryParams.set("limit", limit);

    await fetchAllRFP(page, limit, isOrganizationId, filters); // Properly pass page and limit
  };

  const getKAMName = (ids) => {
    if (!Array.isArray(ids) || ids.length === 0) return "No KAM Assigned";

    // Map through IDs and find corresponding KAM details
    const kamDetails = ids
      .map((id) => {
        const kam = kamdata.find((kam) => kam._id === id);
        return kam ? { name: kam.name, email: kam.email } : null;
      })
      .filter((kam) => kam !== null); // Remove null values

    return kamDetails;
  };

  const EditRFPForm = (e, id) => {
    navigate(`/user/editRFP/${id}`);
  };

  // Keeps track of a delay timer between typing and API call
  const debounceTimeoutRef = useRef(null);

  const handleSearchChangeHead = (e, key) => {
    const value = e.target.value.toLowerCase(); // Get the user's typed value and lowercase it

    // Update the searchInputs state
    setSearchInputs((prevState) => {
      const updatedInputs = { ...prevState, [key]: value };

      // Cancel any previous debounce timer
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }

      // Set a new debounce timer (500ms)
      debounceTimeoutRef.current = setTimeout(() => {
        const allFieldsEmpty = Object.values(updatedInputs).every(
          (val) => val.trim() === ""
        );

        if (allFieldsEmpty) {
          // No search filters entered → fetch all data
          fetchAllRFP(1, pageSize, isOrganizationId);
        } else {
          // Build filters to pass to API
          const filters = {};
          Object.entries(updatedInputs).forEach(([searchKey, searchValue]) => {
            if (searchValue.trim() !== "") {
              filters[searchKey] = searchValue;
            }
          });

          // Call the API with filters
          fetchAllRFP(1, pageSize, isOrganizationId, filters);
        }
      }, 500); // 500ms delay to wait for user to stop typing

      return updatedInputs; // Return new state to update React state
    });
  };

  return (
    <div>
      <Box>
        {!organizationListLoading ? (
          <>
            <div className="flex justify-between flex-col items-center md:flex-row py-2 bg-[var(--dashboard-bg-color)]">
              <h1 className="text-[20px]">PROPOSALS ({RFPCount}) </h1>

              <div
                className="flex justify-center items-center rounded-full px-1 py-2 space-x-2 text-sm bg-[var(--secondary-color)] text-gray-900"
                style={{ border: "1px solid var(--listdown-color)" }}
              >
                <Search color="var(--listdown-color)" />
                <input
                  type="text"
                  className="outline-none"
                  placeholder={`Search Campaign Name`}
                  onChange={(e) => handleSearchChangeHead(e, columns[0].field)}
                  value={searchInputs?.campaign || ""}
                  autoFocus
                />
              </div>
            </div>

            <Paper
              sx={{
                width: "100%",

                backgroundColor: "white",
                borderRadius: "20px",
              }}
              className="px-4 mt-1 pb-1"
            >
              <>
                <TableContainer
                  sx={{
                    height: "calc(85vh - 125px)", // Adjust this to control available space for the table
                    maxHeight: "calc(85vh - 125px)", // Ensures the table won't exceed this height
                    overflowY: "auto", // Adds scroll when the content exceeds height
                  }}
                  className={`mt-2 rounded-lg  ${Styles["custom-scrollbar"]}`}
                >
                  <Table stickyHeader className="rounded-lg ">
                    <TableHead>
                      <TableRow>
                        {columns.map((column, index) => (
                          <TableCell
                            key={index}
                            sx={{
                              minWidth: column.width,
                              fontWeight: "semibold",
                            }}
                          >
                            <span className=" text-[13px] font-semibold bg-[var(--secondary-color)]">
                              {" "}
                              {column.headerName}{" "}
                            </span>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {allRfp && allRfp?.length > 0 ? (
                        allRfp?.map((row, index) => {
                          const isRowSelected = selected?.includes(row.id);
                          return (
                            <TableRow
                              key={index}
                              selected={isRowSelected}
                              sx={{ borderRadius: "50px", margin: 2 }}
                            >
                              <TableCell>
                                <div className="flex justify-between items-center">
                                  <p>
                                    {row?.campaignName &&
                                      row.campaignName
                                        ?.charAt(0)
                                        .toUpperCase() +
                                        row.campaignName?.slice(1)}
                                  </p>
                                </div>
                              </TableCell>
                              <TableCell>
                                <p>{row?.campaignOwnerId?.name}</p>
                              </TableCell>
                              <TableCell>
                                <p>
                                  {`${new Date(
                                    row?.startDate
                                  ).getDate()} ${new Date(
                                    row?.startDate
                                  ).toLocaleString("default", {
                                    month: "short",
                                  })} ${new Date(
                                    row?.startDate
                                  ).getFullYear()} - ${new Date(
                                    row.endDate
                                  ).getDate()} ${new Date(
                                    row?.endDate
                                  ).toLocaleString("default", {
                                    month: "short",
                                  })} ${new Date(row?.endDate).getFullYear()}`}
                                </p>
                              </TableCell>
                              <TableCell>
                                {(() => {
                                  const kamDetails = getKAMName(
                                    row?.keyAccountManagerId
                                  );

                                  // Handle the case where there are no KAM details
                                  if (row?.keyAccountManagerId.length === 0) {
                                    return <p>No KAM Assigned</p>;
                                  }
                                  return (
                                    <div>
                                      {kamDetails?.map((kam, index) => (
                                        <div key={index}>
                                          <div className="text-[13px]">
                                            {kam.name || "NA"}
                                          </div>
                                          <p className="text-[--para-color] text-[12px]">
                                            {kam.email || "NA"}
                                          </p>
                                        </div>
                                      ))}
                                    </div>
                                  );
                                })()}
                              </TableCell>
                              <TableCell>
                                {(() => {
                                  // Handle the case where there are no KAM details
                                  if (row?.teamMembers.length === 0) {
                                    return <p>No Team Assigned</p>;
                                  }
                                  return (
                                    <div>
                                      {row.teamMembers?.map((team, index) => (
                                        <div key={index}>
                                          <div className="text-[13px]">
                                            {team.name
                                              ?.charAt(0)
                                              .toUpperCase() +
                                              team.name?.slice(1) || "NA"}
                                          </div>
                                          <p className="text-[--para-color] text-[12px]">
                                            {team.emailAddress || "NA"}
                                          </p>
                                        </div>
                                      ))}
                                    </div>
                                  );
                                })()}
                              </TableCell>

                              <TableCell>
                                <a
                                  href={row?.rfpDocument}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex justify-start items-center"
                                >
                                  {row?.campaignName}...
                                  <RightArrowLink
                                    size="15"
                                    color="var(--primary-color)"
                                  />
                                </a>
                              </TableCell>
                              <TableCell>
                                {" "}
                                {(() => {
                                  const statusConfig = {
                                    "Order Confirmed": {
                                      bgColor: "#D0F4FF",
                                      textColor: "#093EBC",
                                      label: "Order Confirmed",
                                    },
                                    "Confirmation Pending": {
                                      bgColor: "#FFDFDF",
                                      textColor: "#8C0909",
                                      label: "Confirmation Pending",
                                    },
                                  };

                                  const status = statusConfig[row.status];
                                  if (!status) return "N/A";

                                  return (
                                    <div
                                      className={`rounded-full flex items-center py-0.5 px-2.5 border border-transparent text-sm transition-all shadow-sm w-fit`}
                                      style={{
                                        backgroundColor: status.bgColor,
                                        color: status.textColor,
                                      }}
                                    >
                                      {status.label}
                                    </div>
                                  );
                                })()}
                              </TableCell>

                              <TableCell>
                                <button
                                  onClick={(e) => EditRFPForm(e, row._id)}
                                  className="text-[var(--primary-color)]"
                                >
                                  View
                                </button>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={columns?.length}
                            sx={{ borderBottom: "none" }}
                          >
                            <div className="flex justify-center items-center h-64">
                              No RFP found
                            </div>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                <hr
                  className="bg-gray-200"
                  style={{ border: "0.5px solid var(--light-grey-color)" }}
                />

                <div className="flex items-center justify-between mt-2 mb-1">
                  <FormControl
                    variant="standard"
                    size="small"
                    sx={{ minWidth: 80 }}
                  >
                    <InputLabel id="page-size-label">Rows</InputLabel>
                    <Select
                      labelId="page-size-label"
                      value={pageSize}
                      onChange={handlePageSizeChange}
                      label="Rows"
                    >
                      {pageSizeOptions.map((size, index) => (
                        <MenuItem key={index} value={size}>
                          {size}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <Pagination
                    className="flex justify-center"
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                    sx={{
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: "#418cff",
                        color: "#fff",
                      },
                      "& .MuiPaginationItem-root.Mui-selected:hover": {
                        backgroundColor: "#3366cc",
                      },
                      "& .MuiPaginationItem-root": {
                        "&:hover": {
                          backgroundColor: "#ddd",
                        },
                      },
                    }}
                  />
                </div>
              </>
            </Paper>
          </>
        ) : (
          <div className="flex justify-center items-center h-64">
            <CircularProgress />
          </div>
        )}
      </Box>
    </div>
  );
};

export default Campaigns;
